import React from 'react';
import ReactDOM from 'react-dom';
import Kit from './kit/kit.js';
import App from './app';

import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloProvider } from 'react-apollo';

var httpLink = createHttpLink({
	uri: 'https://walter-klassen.myshopify.com/api/graphql'
	// uri: 'https://wkfx.myshopify.com/api/graphql'
});

var middlewareLink = setContext(function () {
	return {
		headers: {
			'X-Shopify-Storefront-Access-Token': 'b0dc1e2f7fcb572ce27699d8d428d604'
			// 'X-Shopify-Storefront-Access-Token': '77a7804be34608623eea4980e5610c0c'
		}
	};
});

var client = new ApolloClient({
	link: middlewareLink.concat(httpLink),
	cache: new InMemoryCache()
});

var _ref = React.createElement(
	ApolloProvider,
	{ client: client },
	React.createElement(App, null)
);

var render = function render() {
	if (document.getElementById('kit-builder')) {
		ReactDOM.render(_ref, document.getElementById('kit-builder'));
	}
	return;
};

render();